import React from "react";
import { Store } from "../store";
import useResponsive from "../hooks/useResponsive";
import Menu from "./menu";

const SuperHeader = () => {
  const config = Store.useState(s => s.config);
  const settings = config.eshop.theme.selected.settings;
  const { isMobile } = useResponsive({ maxWidth: settings?.mobileBreakpoint });

  const { display, backgroundColor } = settings.superHeader;

  if (!display) return null;
  else if (display) {
    const menu = config.eshop.menus.find(m => m.location === "topHeader");
    if (!menu) return <p>Menu not found</p>;
    else return (
      <div id="topHeader" className={isMobile ? "mobile" : ""}>
        <Menu location="topHeader" styles={{ backgroundColor: backgroundColor ? `var(--${backgroundColor.id})` : "inherit" }} />
      </div>);
  } else return null;
};

export default SuperHeader;
